import {
	Pipe,
	PipeTransform
}                                 from '@angular/core';
import { DateUtilsHelperService } from '@utils/helpers/date-utils-helper.service';

@Pipe( {
	name: 'dateLocaleFormat',
	pure: false
} )
export class DateLocaleFormatPipe implements PipeTransform {

	constructor(
		private readonly dateUtilsHelperService: DateUtilsHelperService
	) {}

	transform(
		date: Date,
		options?: Intl.DateTimeFormatOptions,
		spare: string = ''
	): string {
		return this.dateUtilsHelperService.getLocaleDateString( date, options, spare );
	}
}
